import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHeading = styled.h2`
  margin: 0;
  padding: 12px 0;

  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  text-transform: uppercase;

  position: relative;

  border-top: 1px solid ${p => p.theme.color.borderPrimary};

  cursor: pointer;

  &::before,
  &::after {
    display: block;
    content: '';

    width: 12px;
    height: 3px;
    border-radius: 3px;

    background-color: ${p => p.theme.color.primary};

    position: absolute;
    top: 19px;
  }

  &::before {
    transform: ${p => (p.active ? 'rotate(-45deg)' : 'rotate(45deg)')};
    right: 15px;
  }

  &::after {
    transform: ${p => (p.active ? 'rotate(45deg)' : 'rotate(-45deg)')};
    right: 8px;
  }
`;

class Heading extends React.PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  };

  onClick = () => this.props.onClick(this.props.id);

  render() {
    const { active, children, className } = this.props;

    return (
      <StyledHeading
        active={active}
        className={className}
        onClick={this.onClick}
      >
        {children}
      </StyledHeading>
    );
  }
}

export default Heading;
